import { helpTopics, assistantMenu, wherePaths, whereLinks } from './knowledgeText';
import { isInternalTopic } from '../utils/menuMap';

const STOP = new Set(['the', 'and', 'for', 'how', 'do', 'does', 'did', 'to', 'in', 'on', 'of', 'is', 'are', 'a', 'an', 'i', 'my', 'me',
  'where', 'what', 'can', 'it', 'find', 'with', 'from', 'at', 'be', 'by', 'or']);

let index = null;

/** Every help topic as searchable text, built once; the account manager topics ('partner-...') are flagged. */
function topics() {
  if (!index) {
    const menu = assistantMenu();
    index = helpTopics()
      .filter((t) => !isInternalTopic(t.key))
      .map((t) => ({ ...t, partner: t.key.startsWith('partner-'), where: wherePaths(t.key, menu), links: whereLinks(t.key, menu), lower: t.text.toLowerCase(), titleLower: (t.title || '').toLowerCase() }));
  }
  return index;
}

/** The part of the text around the first match, for showing why a topic matched. */
function snippet(topic, tokens) {
  const first = tokens.map((t) => topic.lower.indexOf(t)).filter((i) => i >= 0).sort((a, b) => a - b)[0];
  if (first === undefined) return topic.text.replace(/#{1,6}\s+/g, '').replace(/\s+/g, ' ').slice(0, 140);
  const from = Math.max(0, first - 50);
  const text = topic.text.replace(/#{1,6}\s+/g, '').replace(/\s+/g, ' ');
  return `${from > 0 ? '...' : ''}${text.slice(from, from + 150)}${from + 150 < text.length ? '...' : ''}`;
}

/**
 * The help topics that best answer a few typed words: [{ key, title, where, links, snippet }], best first. The topics for
 * account managers only are left out unless `partner` is set (Account Management > Search & Ask).
 */
export function searchHelp(query, limit = 8, { partner = false } = {}) {
  const tokens = (query || '').toLowerCase().split(/[^a-z0-9]+/).filter((t) => t.length > 1 && !STOP.has(t));
  if (tokens.length === 0) return [];
  const scored = topics().filter((t) => partner || !t.partner).map((topic) => {
    let matched = 0;
    let score = 0;
    tokens.forEach((t) => {
      const inTitle = topic.titleLower.includes(t);
      const inText = topic.lower.includes(t);
      const inWhere = topic.where.some((w) => w.toLowerCase().includes(t));
      if (inTitle || inText || inWhere) matched += 1;
      score += (inTitle ? 5 : 0) + (inWhere ? 3 : 0) + (inText ? 1 + Math.min(3, topic.lower.split(t).length - 1) * 0.2 : 0);
    });
    return { topic, matched, score };
  });
  const need = tokens.length <= 2 ? tokens.length : Math.ceil(tokens.length / 2);
  return scored
    .filter((s) => s.matched >= need)
    .sort((a, b) => b.matched - a.matched || b.score - a.score)
    .slice(0, limit)
    .map(({ topic }) => ({ key: topic.key, title: topic.title, where: topic.where, links: topic.links, snippet: snippet(topic, tokens) }));
}
